import Banner from 'app/components/partials/banner';
import CategorySelector from 'app/components/partials/category-selector';
import ContentBlocks from 'app/components/content-blocks/index';
import FilterStories from 'app/components/partials/filter-stories.container';
import formatContent from 'app/utilities/format-content';
import NewsHero from 'app/components/partials/news-hero';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

class News extends Component {
    render() {
        const {
            blocks = [],
            intro_content: intro,
            name: title,
            highlighted_information: highlight,
            main_images: images = [],
            latin_name: latinName,
            short_description: description,
        } = this.props.data;

        return (
            <div className="page || news-view">
                <Banner
                    title={title}
                    subtitle={latinName}
                    introduction={description}
                    highlight={highlight}
                    images={images} />
                <CategorySelector categories={this.props.newsCategories} />
                {/* Editor HTML, so it can link out to the animal and category
                    pages behind the listing. Sits under the category navigation,
                    matching where the category pages put their own intro. */}
                {intro && (
                    <div className="news-intro">
                        <div className="constrain-width large">
                            <div
                                className="rich-editor-content"
                                dangerouslySetInnerHTML={{ __html: formatContent(intro) }} />
                        </div>
                    </div>
                )}
                <NewsHero
                    featuredNews={this.props.featuredNews}
                    latestNews={this.props.latestNews}
                    popularNews={this.props.popularNews} />
                {/* Unticked shows every category, which is what the landing page wants */}
                <FilterStories
                    activeCategories={this.props.activeCategories}
                    listingPage={this.props.listingPage}
                    categories={this.props.newsCategories} />
                <ContentBlocks data={blocks} hasListing={true} />
            </div>
        );
    }
}

News.propTypes = {
    activeCategories: PropTypes.array,
    listingPage: PropTypes.number,
    children: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.array
    ]),
    data: PropTypes.object.isRequired,
    featuredNews: PropTypes.array,
    latestNews: PropTypes.array,
    newsCategories: PropTypes.array,
    popularNews: PropTypes.array
};

export default News;
